import _ from "lodash";
import { ServiceConfig } from "../types";

export abstract class AbstractService {
  constructor(protected config: ServiceConfig = {}) {
    /* empty */
  }

  public setConfig(config: ServiceConfig) {
    this.config = config;
  }

  public unsetConfig(fields?: string[]) {
    this.config = fields ? _.omit(this.config, fields) : {};
  }

  public patchConfig(config: Partial<ServiceConfig>) {
    this.config = _.assign(this.config, config);
  }

  protected checkConfig(keys: keyof ServiceConfig | (keyof ServiceConfig)[]) {
    const emptyKeys = _.filter(
      Array.isArray(keys) ? keys : [keys],
      (k: string) =>
        !(k in this.config) ||
        /* eslint-disable */
        // @ts-ignore
        this.config[k] === undefined
        /* eslint-enable */
    );
    if (emptyKeys.length) {
      throw new Error(
        `Empty config field${emptyKeys.length > 1 ? "s" : ""}: ${emptyKeys.join(
          ", "
        )}`
      );
    }
  }
}
